import React, { useEffect, useState } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Box,
    TextField, MenuItem, Button, Slide, Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Icon } from '@iconify/react/dist/iconify.js';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const BulkReassignModal = ({ open, count = 0, societyOptions = [], submitting = false, onClose, onConfirm }) => {
    const [societyId, setSocietyId] = useState('');
    useEffect(() => { if (open) setSocietyId(''); }, [open]);

    return (
        <Dialog open={open} onClose={submitting ? undefined : onClose} TransitionComponent={Transition}
            maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
            <Box sx={{ background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)', color: 'white' }}>
                <DialogTitle sx={{ p: 2.5 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                            <Icon icon="mdi:office-building-marker-outline" width="26" height="26" />
                            <Typography variant="h6" sx={{ fontWeight: 700, color: 'white' }}>Reassign to Community</Typography>
                        </Box>
                        <IconButton onClick={onClose} disabled={submitting} size="small"
                            sx={{ color: 'white', backgroundColor: 'rgba(255,255,255,0.15)' }}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </Box>
                </DialogTitle>
            </Box>

            <DialogContent sx={{ p: 2.5, bgcolor: '#f8fafc' }}>
                <Typography variant="body2" sx={{ mb: 2, mt: 1 }}>
                    Move <strong>{count}</strong> selected employee{count === 1 ? '' : 's'} to another community.
                </Typography>
                <TextField select label="Target Community" size="small" fullWidth required
                    value={societyId} onChange={(e) => setSocietyId(e.target.value)}>
                    <MenuItem value=""><em>Select community</em></MenuItem>
                    {societyOptions.map((o) => (<MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>))}
                </TextField>
                <Box sx={{ mt: 2, p: 1.5, borderRadius: 1.5, bgcolor: '#fffbeb', border: '1px solid #fde68a' }}>
                    <Typography variant="caption" sx={{ color: '#92400e' }}>
                        <Icon icon="mdi:information-outline" style={{ verticalAlign: 'middle', marginRight: 6 }} />
                        This changes the employee record only. It does not move the linked login account's
                        access to the new community — that is a separate step.
                    </Typography>
                </Box>
            </DialogContent>

            <DialogActions sx={{ p: 2, gap: 1, bgcolor: '#f8fafc', borderTop: '1px solid #e2e8f0' }}>
                <Button onClick={onClose} disabled={submitting} variant="outlined"
                    sx={{ borderColor: 'rgba(0,0,0,0.23)', color: 'text.primary' }}>Cancel</Button>
                <Button onClick={() => societyId && onConfirm(societyId)} disabled={!societyId || submitting} variant="contained"
                    sx={{ backgroundColor: '#f59e0b', '&:hover': { backgroundColor: '#d97706' } }}>
                    {submitting ? 'Reassigning…' : 'Reassign'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default BulkReassignModal;
